<template>
  <AlertsDialog
    v-if="rhythmId && companyName"
    :rhythm_id="rhythmId"
    :companyName="companyName"
  >
    <template #default="{ on }">
      <button
        v-on="on"
        class="isigma_members_btn"
      >
        Sign Up for Alerts
      </button>
    </template>
  </AlertsDialog>
</template>
  
<script>
  import AlertsDialog from "@/components/AlertsDialog.vue";
  
  export default {
    components: {
      AlertsDialog,
    },
    computed: {
      rhythmId () {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('rhythm_id');
      },
      companyName () {
        return document.querySelector('h1').innerHTML;
      }
    }
  };
</script>